<template lang="pug">
    .play-box
        template(v-if='!isLoading')
                game-header(
                    v-if="!isBattle"
                    @soundStateChanged ="headerKey = !headerKey"
                    :key="headerKey"
                    :slug='type',
                    :game-type='parameters && parameters.courseType',
                    :is-homework="!!exerciseId",
                )
                .play-box__game(v-if='gameStarted && !gameFinished')
                    .play-box__example
                        .play-box__overflow-container
                            .play-box__field(:style="exampleStyle")
                                .play-box__letter-container(
                                        v-for="(letter, index) in wholeWordForCurrentExample"
                                    )
                                    .letter(
                                        :style="{opacity: letter === '_' ? 0 : 1}"
                                        @click="insertPossibleAnswer(letter, index)"
                                    ) {{ letter }}
                            cs-button.play-box__next-example-button(
                                    v-if="!isCorrectAnswerGiven",
                                    @click="processReply()",
                                    pattern="primary-outline",
                                    color="blue"
                                )  {{ $i18n.t('trainer.trainer_gamePlayBox_checkAnswer') }}
                            cs-button.play-box__next-example-button(
                                    v-if="showHintButton",
                                    @click="showHint",
                                    pattern="primary-outline",
                                    color="blue"
                                )  {{ $i18n.t('trainer.trainer_gamePlayBox_tip') }}
                            cs-button.play-box__next-example-button(
                                    v-if="isCorrectAnswerGiven",
                                    @click="nextExample",
                                    pattern="primary-outline",
                                    color="blue"
                                )  {{ $i18n.t('olympiads.olympiads_processStage_further') }}
                .game-info__block(v-if="gameStarted && !gameFinished")
                        game-info(
                            :score="{left: answers.good, right: answers.bad}"
                            :time="getTime"
                            :slug="type"
                            :parameters="parameters"
                            :game-allows-tips="false"
                            :opponent="opponent"
                            :opponent-numbers="opponentNumbers"
                            :is-opponent-answering="isOpponentAnswering"
                            :is-from-battle="isBattle"
                            :is-olympiad="isOlympiad"
                        )
                .play-box__end-container(v-if='gameFinished && !isOlympiad')
                    fireworks(
                        v-if="gameFinished && !isOlympiad && gameResult === 'success' "
                        :is-mobile="isMobile"
                    )
                    .play-box__reaction-container
                            .play-box__answers.play-box__answers--left
                                | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                                br
                                | {{ getTime }}
                            result-image.play-box__image(:status="gameResult")
                            .play-box__answers.play-box__answers--right
                                | {{ $i18n.t('dashboard.dashboard_sidebar_statistics') }}
                                br
                                | {{ answers.good }} / {{ answers.bad }}
                    result-buttons(
                        v-if="!isBattle"
                        :exercise-id="exerciseId"
                        :games-type="parameters.courseType"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
                calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import TransfersSyllablesSchoolPreparing from '@/api/games/transfersSyllablesSchoolPreparing';
    import textScrollMixin from '../../../../utils/trainer/textScroll';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadRussianLanguageAnswerTimerMixin from '../../../../utils/olympiads/olympiadRussianLanguageAnswerTimerMixin.js';
    import Battle from '../../../../utils/battle/battleMixin';
    import { cloneDeep } from 'lodash';
    import CsButton from '@/elements/CsButton.vue';
    import CsLoader from '@/elements/CsLoader.vue';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';

    const WIDTH_COEFFICIENT = 13;
    const DEFAULT_VOLUME = 0.6;

    function DEFAULT_DATA() {
        return {
            examples: null,
            clientWidth: 0,
            currentLevel: 0,
            answers: { good: 0, bad: 0 },
            isCorrectAnswerGiven: false,
            isWrongAnswerGiven: false,
            showAnswersInDictationMode: false,
            userAnswer: null,
            wholeWordForCurrentExample: null,
            correctAnswerWithAllElements: null,
            changedIndexs: [],
            badAnswersInOneExample: 0,
            showHintButtonClicked: false,
        };
    }

    export default {
        mixins: [textScrollMixin, playBoxGameMixin, olympiadRussianLanguageAnswerTimerMixin, Battle],
        created() {
            window.addEventListener('resize', this.getClientWidth);
        },
        mounted() {
            document.addEventListener('keydown', this.handleKeyPress);
        },
        data() {
            return DEFAULT_DATA();
        },
        computed: {
            gameResult() {
                if (this.answers.good >= this.answers.bad) return 'success';
                else return 'failure';
            },
            exampleStyle() {
                if (this.userAnswer && this.isWrongAnswerGiven) return { border: '3px solid hsl(353, 100%, 62%)' };
                if (this.userAnswer && this.isCorrectAnswerGiven) return { border: '3px solid rgb(130, 176, 90)' };
                return {
                    border: 'none',
                };
            },
            isInfiniteAmountOfExamples() {
                return this.parameters.timeLimit || this.parameters.infinityAmountOfExamples ? 1 : 0;
            },
            possibleAnswer() {
                return this.parameters.theme === 'transfers' ? '-' : '/';
            },
            correctAnswer() {
                if (this.parameters.theme === 'transfers') {
                    return this.examples[this.currentLevel].transferWord;
                } else {
                    return this.examples[this.currentLevel].syllableWord;
                }
            },
            preparedCorrectAnswer() {
                if (this.parameters.theme === 'transfers') {
                    return this.examples[this.currentLevel].transferWord.split(' ');
                } else {
                    return this.examples[this.currentLevel].syllableWord.split(' ');
                }
            },
            showHintButton() {
                return this.badAnswersInOneExample >= 3 && this.parameters.isHintEnabled;
            },
        },
        methods: {
            handleKeyPress(event) {
                if (event.key === 'Enter' && !this.gameFinished) {
                    if (!this.isCorrectAnswerGiven) {
                        return this.processReply();
                    };
                    if (this.isCorrectAnswerGiven) {
                        return this.nextExample();
                    };
                }
            },
            processReply(finishExample = false) {
                this.userAnswer = this.getTheUserAnswer();
                if (this.preparedCorrectAnswer.includes(this.userAnswer)) {
                    this.isWrongAnswerGiven = false;
                    this.isCorrectAnswerGiven = true;
                    this.answers.good++;
                } else {
                    this.isWrongAnswerGiven = true;
                    this.deleteWorngUserAnswers();
                    this.answers.bad++;
                    this.badAnswersInOneExample++;
                }
                this.changedIndexs = [];
                if (this.isOlympiad || this.isBattle || finishExample) {
                    this.nextExample();
                }
            },
            deleteWorngUserAnswers() {
                this.correctAnswerWithAllElements[0].forEach((letter, index) => {
                    if (this.wholeWordForCurrentExample[index] !== letter && this.changedIndexs.includes(index)) {
                        this.wholeWordForCurrentExample[index] = letter;
                    }
                });
            },
            showHint() {
                this.showHintButtonClicked = true;
                this.wholeWordForCurrentExample = this.correctAnswerWithAllElements[0];
                this.isCorrectAnswerGiven = true;
            },
            nextExample() {
                this.stopAnswerTimer();
                if (!this.isInfiniteAmountOfExamples && this.currentLevel === this.parameters.amountOfExamples - 1) {
                    this.finishGame();
                    return;
                }
                this.currentLevel++;
                this.isCorrectAnswerGiven = false;
                this.userAnswer = null;
                this.showHintButtonClicked = false;
                this.badAnswersInOneExample = 0;
                this.wholeWordForCurrentExample = this.getWholeWordForCurrentExample();
                this.correctAnswerWithAllElements = this.getCorrectAnswerWithAllElements();
                this.startAnswerTimer();
            },
            insertPossibleAnswer(letter, index) {
                this.isWrongAnswerGiven = false;
                if (this.isCorrectAnswerGiven) return;
                if (letter === this.possibleAnswer) {
                    if (this.changedIndexs.includes(index)) {
                        this.changedIndexs = this.changedIndexs.filter(item => item !== index);
                    }
                    this.$set(this.wholeWordForCurrentExample, index, '_');
                }
                if (letter === '_') {
                    this.changedIndexs.push(index);
                    this.$set(this.wholeWordForCurrentExample, index, this.possibleAnswer);
                }
            },
            getTheUserAnswer() {
                return this.wholeWordForCurrentExample.filter(item => item !== '_').join('');
            },
            registerSounds() {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
                this.$createjs.Sound.registerSounds(this.soundObjects);
            },
            fetchData() {
                this.getExercise()
                    .then(() => {
                        TransfersSyllablesSchoolPreparing.getItemsByRequest({
                            isInfiniteAmountOfExamples: this.isInfiniteAmountOfExamples,
                            amountOfExamples: this.parameters.amountOfExamples,
                            difficultWords: this.parameters.difficultWords,
                        })
                            .then(data => {
                                this.examples = data;
                                this.startGame();
                                this.registerSounds();
                                this.isLoading = false;
                            })
                            .catch(e => this.showErrorMessage(e));
                    })
                    .catch(e => {
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            refreshGameStatBeforeSend() {
                this.gameStat.answers = this.answers.good;
                this.gameStat.amountOfMistakes = this.answers.bad;
                this.gameStat.attempts = this.currentLevel + 1;
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.amountOfExamples = this.parameters.amountOfExamples;
                this.gameStat.parameters = cloneDeep(this.parameters);
            },
            startGame() {
                this.gameStarted = true;
                this.wholeWordForCurrentExample = this.getWholeWordForCurrentExample();
                this.correctAnswerWithAllElements = this.getCorrectAnswerWithAllElements();
                this.startTimer();
            },
            getCorrectAnswerWithAllElements() {
                const answerVariants = this.correctAnswer.split(' ');

                return answerVariants.map((variant) => {
                    let splitArray = variant.split('');
                    return splitArray.reduce((result, item, index, initialArray) => {
                        const nextItem = initialArray[index + 1];
                        result.push(item);
                        if (
                            item !== this.possibleAnswer &&
                            nextItem !== this.possibleAnswer &&
                            index !== initialArray.length - 1
                        ) {
                            result.push('_');
                        }
                        return result;
                    }, []);
                });
            },
            getWholeWordForCurrentExample() {
                let resultArray = [];
                let splitArray = this.examples[this.currentLevel].wholeWord.split('');
                splitArray.forEach((letter, index) => {
                    resultArray.push(letter);
                    if (index !== splitArray.length - 1) {
                        resultArray.push('_');
                    }
                });
                return resultArray;
            },
            startTimer() {
                this.startAnswerTimer();
                this.$nextTick(() => {
                    if (!this.timer) {
                        this.setTimer();
                    }
                });
            },
            finishGame() {
                this.gameFinished = true;
                this.stopTimer();
                this.soundInstance = this.$createjs.Sound.play('gameDone');
                this.sendStat();
            },
            calculatePercent() {
                let total = this.answers.good + this.answers.bad;
                if (total > 0) {
                    return parseInt((this.answers.good / total) * 100);
                }
                return 0;
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.handleKeyPress);
            window.removeEventListener('resize', this.getClientWidth);
        },
        components: {
            CsLoader,
            CsButton,
            CalculatingAnswers,
        },
    };
</script>

<style lang="scss" scoped>
    @import '@/assets/sass/games/playbox.scss';

    .play-box {
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        width: 100%;
        align-items: center;
        flex-direction: column-reverse;
        @media screen and (min-width: 835px) {
            align-items: stretch;
            flex-direction: row;
        }
    }

    .mobile-version {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .play-box--warning {
        display: table;
    }

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column-reverse;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__example {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 5;
        flex-direction: column;
    }

    .play-box__overflow-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .play-box__field {
        padding: 0 20px;
        text-align: center;
        font-size: 19px;
        user-select: none;
        font-weight: bold;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 0.1em;
        @include media($sm) {
            font-size: 25px;
        }
        @include media($md) {
            font-size: 29px;
        }
        @include media($lg) {
            font-size: 37px;
        }
        @include media($xlg) {
            font-size: 51px;
        }
        @include media($xl) {
            font-size: 68px;
        }
    }

    .play-box__words-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .play-box__answer-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .answer-container__header {
        margin-bottom: 20px;
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
    }

    .answer-container__input .cs-input {
        margin-bottom: 0;
        font-size: 52px;
        line-height: 62px;
        padding: 9px 15px;
        text-align: center;
        max-width: 330px;
    }

    .play-box__word {
        padding: 0 8px;
        margin: 0 10px 3px 0;
        cursor: pointer;
    }

    .play-box__word:last-child {
        margin-right: 0;
    }

    .play-box__word--selected {
        color: $x-color-white;
        background: $hsl-color-green-58;
    }

    .play-box__word--unselected {
        color: $x-color-white;
        background: $hsl-color-red-62;
    }

    .play-box__word--inverted {
        display: inline-block;
        transform: rotate(180deg);
        margin-right: 10px;
    }

    .play-box__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        font-weight: 500;
        font-size: 28px;
        line-height: 34px;
        margin-bottom: 20px;
    }

    .play-box__before-start-game-header {
        flex-direction: column;
    }

    .play-box__task {
        align-self: center;
    }

    .play-box__title {
        margin-bottom: 20px;
        text-align: center;
    }

    .play-box__scaling-bar-block {
        margin-left: 20px;
        @include media($xlg) {
            margin-left: 40px;
        }
    }

    .play-box__subtitle {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 0;
        justify-content: center;
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        @include media($md) {
            flex-direction: row;
        }
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__answers--left {
        color: $hsl-color-green-58;
        margin-left: 20px;
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers--right {
        color: $hsl-color-green-58;
        margin-right: 20px;
        @include media($lg) {
            margin-right: 35px;
        }
    }

    .play-box__answers--show-md {
        display: block;
    }

    .play-box__answers-container {
        display: flex;
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 40px;
        @media screen and (max-width: 1200px) {
            height: 400px;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 25px;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__buttons--game {
        margin: 0 0 25px;
        justify-content: center;
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .play-box__game-info {
        align-self: flex-end;
        @include media($lg) {
            align-self: auto;
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .play-box__answers-field {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
    }

    .play-box__answer {
        margin: 10px;
        padding: 15px;
        border: 3px solid $hsl-color-gray-74;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .play-box__next-example-button {
        margin-top: 15px;
    }

    .divide-it-right__answer-buttom {
        display: flex;
        flex-direction: column;
        align-items: center;
        @include inset-space($space-base);
    }

    .divide-it-right__answer-turtle {
        max-width: 180px;
        @include stack-space($space-base);
        @include media($xlg) {
            max-width: 240px;
        }
    }

    .play-box__letter-container {
        cursor: pointer;
        width: 15px;
        @include media($sm) {
            width: 20px;
        }
        @include media($md) {
            width: 25px;
        }
        @include media($lg) {
            width: 29px;
        }
        @include media($xlg) {
            width: 33px;
        }
        @include media($xl) {
            width: 40px;
        }
        &.not-letter {
            min-width: 0.8em;
            transition-property: all;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            transition-duration: 150ms;
            &:hover {
                background: #00000024;
                border-radius: 0.1em;
            }
        }
    }
</style>
